import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import t from "@/lang/lang";
import { MonitorIoTClassUtil } from "@/services/backend/qpm/lib/monitor-iot-class-util";
import { MonitorIoTClass } from "@/services/backend/qpm/types/enums";

export function MonitorIoTSpecComponent({
  monitorId,
  iotSpec,
}: {
  monitorId: string;
  iotSpec?: { protocol: string; class: string };
}) {
  if (!iotSpec) return null;

  const protocolId = `monitor-iot-protocol-${monitorId}`;
  const classId = `monitor-iot-class-${monitorId}`;

  const iotClassLabel = iotSpec.class
    ? MonitorIoTClassUtil.toString(iotSpec.class as MonitorIoTClass)
    : "";

  return (
    <div className="flex flex-col gap-2">
      <div className="grid grid-cols-4 items-center gap-1.5">
        <Label className="col-span-2" htmlFor={classId}>
          {t("IoT Typ")}
        </Label>
        <Input
          className="col-span-2"
          id={classId}
          value={iotClassLabel}
          disabled
        />
      </div>
      <div className="grid grid-cols-4 items-center gap-1.5">
        <Label className="col-span-2" htmlFor={protocolId}>
          {t("Protokoll")}
        </Label>
        <Input
          className="col-span-2"
          id={protocolId}
          value={iotSpec.protocol ?? ""}
          disabled
        />
      </div>
    </div>
  );
}
